<template>
  <div>
    <p class="text-2xl mb-6">Création à partir de sources internes</p>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-1">
        <v-col cols="12">
          <internal-sources-filters />
        </v-col>
      </v-row>
    </v-card>

    <v-sheet
      v-if="selectedCount > 0"
      color="primary"
      dark
      rounded
      class="d-flex align-center px-4 py-2 mb-4 sticky-bar"
      elevation="3"
    >
      <span class="font-weight-semibold">
        {{ selectedCount }} article{{ selectedCount > 1 ? "s" : "" }} sélectionné{{
          selectedCount > 1 ? "s" : ""
        }}
      </span>
      <v-spacer />
      <v-btn text small @click="clearSelection">Désélectionner</v-btn>
      <span class="text-caption ml-4 mr-2">Image :</span>
      <!-- Champ blanc (light) : sur la barre primary, l'icone « Générer »
           (couleur primary) serait invisible. -->
      <aif-image-mode-toggle
        v-model="imageHandler"
        layout="select"
        light
        background-color="white"
        class="image-mode-select"
      />
      <v-btn
        color="white"
        light
        class="ml-2"
        :loading="sending"
        @click="confirmDialog = true"
      >
        Envoyer en création
      </v-btn>
    </v-sheet>

    <internal-sources-results />

    <v-dialog v-model="confirmDialog" max-width="480">
      <v-card>
        <v-card-title class="text-h6">Envoyer en rédaction</v-card-title>
        <v-card-text>
          Envoyer
          <b>{{ selectedCount }}</b>
          article{{ selectedCount > 1 ? "s" : "" }} en rédaction
          (brouillon) sur <b>Le Parisien</b> ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="confirmDialog = false">Annuler</v-btn>
          <v-btn color="primary" :loading="sending" @click="doSend">
            Envoyer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "@vue/composition-api";

import AifImageModeToggle from "@/components/ai-factory/common/AifImageModeToggle.vue";
import InternalSourcesFilters from "@/components/ai-factory/internal-sources/Filters.vue";
import InternalSourcesResults from "@/components/ai-factory/internal-sources/Results.vue";

import router from "@/router";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import { saveRmraView } from "@/utils/rmr-analytics";

export default {
  name: "InternalSources",
  components: {
    AifImageModeToggle,
    InternalSourcesFilters,
    InternalSourcesResults,
  },
  setup() {
    const { route, store } = useProxy();
    const { axiosPost } = useAxios();

    const confirmDialog = ref(false);
    const sending = ref(false);

    const imageHandler = computed({
      get: () => store.getters["aiFactory/getGenerationImageHandler"],
      set: (value) =>
        store.dispatch("aiFactory/updateGenerationImageHandler", value),
    });

    const selectedCount = computed(
      () => store.getters["editorial/getSelectedCount"]
    );
    const selected = computed(() => store.getters["editorial/getSelected"]);

    const clearSelection = () => store.dispatch("editorial/clearSelection");

    const snack = (text, color) =>
      store.dispatch("app/setSnackBar", {
        show: true,
        text,
        color,
        timeout: 4000,
      });

    const doSend = async () => {
      if (sending.value || selectedCount.value === 0) return;
      try {
        sending.value = true;
        const {
          data: { sent, errors },
        } = await axiosPost("/editorial/leparisien/send-to-generation", {
          adn_post_ids: selected.value.map((item) => item.id),
          user_email: localStorage.getItem("userEmail"),
          image_handler: imageHandler.value,
        });
        if (errors && errors.length) {
          snack(
            `${sent} envoyé(s), ${errors.length} en erreur : ${errors[0].error}`,
            "warning"
          );
        } else {
          snack(`${sent} article(s) envoyé(s) en rédaction.`, "success");
        }
        clearSelection();
        confirmDialog.value = false;
        if (sent > 0) {
          router.push({ name: "ai-factory-post-generation-list" });
        }
      } catch (error) {
        snack("Échec de l'envoi en rédaction.", "error");
      }
      sending.value = false;
    };

    onMounted(() => {
      store.dispatch("editorial/clearSelection");
      saveRmraView(route);
    });

    return {
      confirmDialog,
      imageHandler,
      sending,
      selectedCount,
      clearSelection,
      doSend,
    };
  },
};
</script>

<style scoped>
.image-mode-select {
  max-width: 220px;
}
.sticky-bar {
  position: sticky;
  top: 0.5rem;
  z-index: 5;
}
</style>
